import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  CREATE_CATEGORY_MOCK,
  DELETE_CATEGORY_MOCK,
  GET_CATEGORIES_MOCK,
  UPDATE_CATEGORY_MOCK,
} from '@shared/mocks/categories.mock';

import {
  Category,
  CategoryNode,
} from './interfaces/categories.interfaces';

import { HttpInterceptor } from '@interceptors/http/http.interceptor';

@Injectable({ providedIn: 'root' })
export class CategoriesService {
  private readonly http = inject(HttpInterceptor);
  private readonly apiUrl = 'categories';

  public getCategories(): Observable<Category[]> {
    return this.http.get(this.apiUrl, GET_CATEGORIES_MOCK);
  }

  public createCategory(formData: FormData): Observable<Category> {
    return this.http.post(this.apiUrl, formData, CREATE_CATEGORY_MOCK);
  }

  public updateCategory(id: string, formData: FormData): Observable<Category> {
    return this.http.patch(`${this.apiUrl}/${id}`, formData, UPDATE_CATEGORY_MOCK);
  }

  public deleteCategory(id: string): Observable<void> {
    return this.http.delete(`${this.apiUrl}/${id}`, DELETE_CATEGORY_MOCK);
  }

  public buildTree(categories: Category[]): CategoryNode[] {
    const byId = new Map<string, CategoryNode>();
    categories.forEach((cat) => {
      byId.set(cat.id, { ...cat, children: [] });
    });

    const roots: CategoryNode[] = [];
    byId.forEach((node) => {
      const parentId = node.parentId ?? null;
      const parentNode = parentId ? byId.get(parentId) : undefined;
      if (parentNode) {
        parentNode.children.push(node);
      } else {
        roots.push(node);
      }
    });

    return roots;
  }
}
